

















































import {
  COLOR_SELECTED_NON_DEFAULT_FILTER_BACKGROUND,
  COLOR_SELECTED_NON_DEFAULT_FILTER_BACKGROUND_DARK,
  COLOR_SELECTED_NON_DEFAULT_TOOLBAR_FILTER_BACKGROUND,
} from "@/utils/colors";
import { themed } from "@/utils/Theme";
import { Vue, Component, Prop, Model } from "vue-property-decorator";

@Component
export default class MenuIconWithMultiSelectionListComponent<T> extends Vue {
  closeOnContentClick = false;

  @Model("valueChanged")
  selection!: T[];

  @Prop()
  defaultSelection!: T[];

  @Prop()
  iconResource!: string;

  /** White in the app bar; a card header passes its own colour, as `FilterMenu` takes it. */
  @Prop({ default: "white" })
  iconColor!: string;

  /** Whether the menu sits in the app bar, which decides the non-default highlight, as in `FilterMenu`. */
  @Prop({ default: true })
  isToolbarIcon!: boolean;

  @Prop()
  tooltip!: string;

  @Prop({ default: [] })
  selectionOptions!: Array<T>;

  @Prop()
  getOptionName!: (value: T) => string;

  @Prop()
  getOptionKeyCallback?: (value: T) => string;

  /**
   * Optional: the name of the group an option belongs to. When given, a heading is shown before the
   * first option of each group; options of one group must be adjacent in `selectionOptions`.
   */
  @Prop()
  getOptionGroup?: (value: T) => string;

  startsGroup(index: number) {
    if (!this.getOptionGroup) {
      return false;
    }

    return (
      index === 0 ||
      this.getOptionGroup(this.selectionOptions[index]) !== this.getOptionGroup(this.selectionOptions[index - 1])
    );
  }

  getOptionKey(value: T) {
    if (this.getOptionKeyCallback) {
      return this.getOptionKeyCallback(value);
    } else {
      value;
    }
  }

  get selectedValues() {
    return this.selection.map((value) => this.getKey(value));
  }

  selectOption(value: T) {
    let newSelection = [...this.selection];

    if (newSelection.includes(value)) {
      newSelection = newSelection.filter((v) => v !== value);
    } else {
      newSelection.push(value);
    }

    this.$emit("valueChanged", newSelection);
  }

  getKey(value: T) {
    return this.getOptionKeyCallback ? this.getOptionKeyCallback(value) : value;
  }

  get style() {
    const isDefaultSelection =
      this.defaultSelection.length === this.selection.length &&
      this.defaultSelection.every((value) => this.selection.includes(value));

    return isDefaultSelection
      ? ""
      : this.isToolbarIcon
        ? `background-color: ${COLOR_SELECTED_NON_DEFAULT_TOOLBAR_FILTER_BACKGROUND}`
        : `background-color: ${themed(COLOR_SELECTED_NON_DEFAULT_FILTER_BACKGROUND, COLOR_SELECTED_NON_DEFAULT_FILTER_BACKGROUND_DARK)}`;
  }
}
